import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="bg-navy text-cream py-16 md:py-24 px-6 relative overflow-hidden" data-id="element-58">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="space-y-8" data-id="element-61">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-cream" data-id="element-62">
              Protege el Legado de tu Familia:{' '}
              <span className="text-gold" data-id="element-63">
                Organiza tus Recuerdos y Documentos Vitales en solo 2 Horas.
              </span>
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-300 font-body leading-relaxed" data-id="element-64">
              El sistema paso a paso diseñado para adultos mayores de 55 años
              que desean orden digital y paz mental sin complicaciones técnicas.
            </h2>
            <div className="pt-4" data-id="element-65">
              <Button data-id="element-66">¡QUIERO ORGANIZAR MI LEGADO FAMILIAR AHORA!</Button>
              <p className="text-sm text-gray-400 mt-4 text-center md:text-left flex items-center justify-center md:justify-start gap-2" data-id="element-67">
                <svg className="w-4 h-4 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-68">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-69"></path>
                </svg>
                Compra segura: Acceso inmediato tras el pago.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-70">
          <div className="relative" data-id="element-71">
            <div className="absolute inset-0 bg-gold rounded-2xl transform translate-x-4 translate-y-4 opacity-50" data-id="element-72"></div>
            <img src="https://cdn.magicpatterns.com/uploads/krAvX7ofgnbLS8EqMrbtmJ/Imagen_de_portada.png" alt="El Family Vault Digital en varios dispositivos" className="relative rounded-2xl shadow-2xl w-full object-cover border-4 border-navy" data-id="element-73" />
          </div>
        </FadeIn>
      </div>
    </section>;
}